import api from "./api";
import { NveAttribute, NveImportResult, NveReference, ProductNve, ProductNveEntry } from "../models/Nve";

const digits = (ncm: string) => ncm.replace(/\D/g, "");

/** Atributos/especificações da tabela NVE do NCM (vazio se a tabela não tem o NCM). */
export const getNveAttributes = async (ncm: string): Promise<NveAttribute[]> =>
  (await api.get(`/api/nve/ncm/${digits(ncm)}`)).data;

export const getProductNve = async (ncm: string, product: string): Promise<ProductNve> =>
  (await api.get("/api/nve/product", { params: { ncm: digits(ncm), product } })).data;

export const saveProductNve = async (ncm: string, product: string, attributes: ProductNveEntry[]) =>
  (await api.put("/api/nve/product", { ncm: digits(ncm), product, attributes })).data;

export const getNveStatus = async (): Promise<{ referenceCount: number }> =>
  (await api.get("/api/nve/status")).data;

export const searchNveReference = async (ncm?: string): Promise<NveReference[]> =>
  (await api.get("/api/nve/reference", { params: { ncm: ncm ? digits(ncm) : undefined } })).data;

export const addNveReference = async (row: Omit<NveReference, "id">) =>
  (await api.post("/api/nve/reference", row)).data;

export const removeNveReference = async (id: string) => (await api.delete(`/api/nve/reference/${id}`)).data;

/** Importa CSV/TSV/JSON; erro de validação (400) devolve o resultado com a lista de erros. */
export const importNveFile = async (file: File): Promise<NveImportResult> => {
  const form = new FormData();
  form.append("file", file);
  try {
    return (await api.post("/api/nve/import", form, { timeout: 300000 })).data;
  } catch (error: any) {
    const data = error?.response?.data;
    if (data && Array.isArray(data.errors)) return data;
    throw error;
  }
};
